<template>
  <div class="container-fluid py-3 px-4">
    <div class="border border-1 rounded-3 p-3 mb-3 ">
      <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-card-checklist display-4 text-primary"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            LISTADO DE POSTULANTES
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            MANTENIMIENTO DE POSTULANTES
          </p>
        </div>
      </div>
    </div>

    <div class="d-flex flex-wrap gap-2 mx-2">

      <button @click="listado" v-if="BotonTabla" class="btn btn-danger text-white">
        <i class="bi bi-skip-backward"></i>
      </button>

      <button v-else @click="Inicio = $router.push('/bienvenido')" class="btn btn-danger text-white">
        <i class="bi bi-skip-backward"></i>
      </button>

      <button @click="postulante" class="btn btn-success text-white" title="AGREGAR NUEVO POSTULANTE">
        <i class="bi bi-person-add"></i>
      </button>

    <!-- [  <button v-b-modal.modal-center class="btn btn-warning text-white" v-if="BotonTabla" title="MODIFICAR POSTULANTE">
        <i class="bi bi-person-fill-gear"></i>
      </button>] -->


      <b-modal id="modal-center" centered title="MODIFICAR USUARIO" @ok="realizarAccionAlAceptar">
        <select @change="selectores = $event.target.value" class="form-select" aria-label="Default select example">
          <option disabled selected>.....</option>
          <option v-for="items in combito" :key="items.id" :value="items.idUsuario">{{ items.usuCodigo }}</option>
        </select>
      </b-modal>
    </div>

    <div v-if="postulanteCondicion" class="mx-2 mt-3">

      <!-- ALERTA -->
      <div class="col-12">
        <div v-if="alerta" class="alert alert-danger mt-2 text-center">
          ¡Éxito! Registro eliminado correctamente.
        </div>
      </div>

      <!-- 🔹 CONTENEDOR -->
      <div class="row border border-1 rounded-3 p-3 mb-3 ">

        <div v-if="mostrarInput">

          <!-- Contador -->
          <div class="d-flex justify-content-end">
            <span v-if="tabla1" class="reducirTamaño fw-semibold text-secondary">
              N° POSTULANTES : <span class="text-dark">{{ Info.length }}</span>
            </span>

            <span v-if="!tabla1" class="reducirTamaño fw-semibold text-secondary">
              N° POSTULANTES : <span class="text-dark">{{ Respuesta.length }}</span>
            </span>
          </div>

          <p v-if="alertita" class="text-danger fw-semibold mt-2">
            ¡ALERTA! No se encontraron registros con los criterios de búsqueda.
          </p>

        </div>
        <div class="d-flex justify-content-end mt-2">
          <span for="" class="input-group-text mt-3 buscar-estiloCuadrado"> <i class="bi bi-search"></i></span>
          <input class="form-control w-25 mt-3 me-2 buscar-estiloCuadrado" v-model="dni_busqueda" type="text"
            maxlength="100"
            oninput="if(this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            placeholder="POR DOCUMENTO DE IDENTIDAD / APELLIDOS" @input="Filtros"
            aria-label=".form-control-lg example" />
        </div>

        <div class="table-responsive mx-2 mt-2">

          <div v-if="Loader" class="w-full overflow-hidden  mt-3">
            <b-row class="mt-1">
              <b-col cols="12" class="mt-5">
                <b-skeleton-img no-aspect height="380px"></b-skeleton-img>
              </b-col>
            </b-row>
          </div>

          <table class="table table-bordered" v-if="tabla1">
            <thead class="reducirTamaño">
              <tr class="bg-solimano text-white text-center text-nowrap">
                <th scope="col">ID</th>
                <th scope="col">CV</th>
                 <th>ESTADO DEL TRABAJADOR</th>
                <th>ULTIMO RQ</th>
                <th scope="col">RECORD TRABAJADOR</th>
                <th scope="col">PERFIL PROFESIONAL</th>
                <th scope="col">NRO. DOC.</th>
                <th scope="col">TIP. DOC.</th>
                <th scope="col">AP. PATERNO</th>
                <th scope="col">AP. MATERNO</th>
                <th scope="col">NOMBRES</th>
                <th scope="col">UBIGEO</th>
                <th scope="col">NACIONALIDAD</th>
                <th scope="col">ACCION</th>
                <th scope="col">ESTADO</th>
              </tr>
            </thead>

            <tbody v-for="(items, index) in datosPaginados" :key="index.id">
              <tr class="text-center align-middle reducirTamaño">

                <td class="tabla-estiloCompreso">
                  <div class="mx-2">
                    <i class="bi bi-hash text-primary me-1"></i>
                    {{ items.idPostulante }} 
                  </div>
                </td>

                <!-- CV -->
                <td v-if="items.posAdjunto != 1" class="text-center py-1">
                  <a :href="url + items.posAdjunto.slice(45)" target="_blank" class="btn btn-light py-1">
                    <i class="bi bi-download fs-6"></i>
                  </a>
                </td>
                <td v-else class="text-center">-</td>
                <td :class="{
                        'text-primary': items.estadoActivo.slice(0,10) == 'CONTRATADO', 'text-danger': items.estadoActivo.slice(0,10) != 'CONTRATADO', 'text-warning': items.estadoActivo == 'EN PROCESO'
                      }" class="fw-bold "> {{ items.estadoActivo }}</td>
                      
                       <td> <button @click="abrirSolicitud(items.requerimiento)" class="btn btn-link-estilo reducirTamaño">{{ items.requerimiento }}</button> </td>
                <td
                  :class="{
                    'text-danger': JSON.parse(items.recordTrabajador).diasAcumulados >= 1260
                  }"
                >
                  {{
                    JSON.parse(items.recordTrabajador).diasAcumulados === 0
                      ? '0 días'
                      : JSON.parse(items.recordTrabajador).diasAcumulados === 1
                        ? '1 día'
                        : `${JSON.parse(items.recordTrabajador).diasAcumulados} días`
                  }}
                </td>                <!-- Perfil -->
                <td><i class="bi bi-person-badge-fill text-secondary me-1"></i>{{ items.posPerProfesional }}</td>

                <!-- Nro Doc -->
                <td><i class="bi bi-credit-card-2-front text-primary me-1"></i>{{ items.posNroDocumento }}</td>

                <!-- Tipo Doc -->
                <td><i class="bi bi-card-heading text-info me-1"></i>{{ items.desTipDocumento }}</td>

                <!-- Paterno -->
                <td><i class="bi bi-person-fill text-secondary me-1"></i>{{ items.posApePaterno }}</td>

                <!-- Materno -->
                <td><i class="bi bi-person-fill text-secondary me-1"></i>{{ items.posApeMaterno }}</td>

                <!-- Nombres -->
                <td><i class="bi bi-person-lines-fill text-success me-1"></i>{{ items.posNombre }}</td>

                <!-- Ubigeo -->
                <td>
                  <i class="bi bi-geo-alt-fill text-danger me-1"></i>
                  {{ items.desDepartamento }} - {{ items.desProvincia }} - {{ items.desDistrito }}
                </td>

                <!-- Nacionalidad -->
                <td>
                  <i class="bi bi-flag-fill text-warning me-1"></i>
                  {{ items.desNacionalidad }}
                </td>

                <!-- Acciones -->
                <td class="py-1 px-1 text-center">

                  <button class="btn btn-outline-info boton-estiloCuadrado me-1" @click="mandar(items.idPostulante)">
                    <i class="bi bi-eye"></i>
                  </button>

                  <button class="btn btn-outline-success boton-estiloCuadrado me-1"
                    @click="editar(items.idPostulante, items.posNroDocumento)">
                    <i class="bi bi-pencil-fill"></i>
                  </button>

                  <button class="btn btn-outline-danger boton-estiloCuadrado" @click="eliminar(items.idPostulante)">
                    <i class="bi bi-trash3"></i>
                  </button>

                </td>

                <!-- ESTADOS -->
                <td v-if="items.posEstado == '002' && items.posMotBloqueo != '000'" class="text-danger fw-bold">
                  <i class="bi bi-x-octagon-fill me-1"></i> BLACKLIST
                </td>

                <td v-if="items.posEstado == '004' && items.posMotBloqueo != '000'" class="text-danger fw-bold">
                  <i class="bi bi-ban-fill me-1"></i> LISTA DE RESTRICCIÓN
                </td>

                <td v-if="items.posEstado == '001' && items.posMotBloqueo == '000'" class="text-success fw-bold">
                  <i class="bi bi-bag-plus me-1"></i> ACTIVO
                </td>

                <td v-if="items.posEstado == '002' && items.posMotBloqueo == '000'" class="text-danger fw-bold">
                  <i class="bi bi-slash-circle-fill me-1"></i> INACTIVO
                </td>

              </tr>

            </tbody>
          </table>

          <table v-else class="table table-bordered mt-2 text-nowrap tamaño">
            <thead>
              <tr class="bg-solimano text-white text-center">
                <th>ID</th>
                <th>CV</th>
                <th>ESTADO DEL TRABAJADOR</th>
                <th>ULTIMO RQ</th>
                <th scope="col">RECORD TRABAJADOR</th>
                <th>PERFIL PROFESIONAL</th>
                <th>NRO. DOC.</th>
                <th>TIP. DOC.</th>
                <th>AP. PATERNO</th>
                <th>AP. MATERNO</th>
                <th>NOMBRES</th>
                <th>UBIGEO</th>
                <th>NACIONALIDAD</th>
                <th>ACCION</th>
                <th>ESTADO</th>
              </tr>
            </thead>
            <tbody>

              <tr v-if="loading">
                <td colspan="11" class="text-center align-middle" style="height: 250px;">
                  <div class="d-flex flex-column align-items-center justify-content-center h-100">
                    <div class="spinner-border text-warning" role="status" style="width: 4rem; height: 4rem;"></div>
                    <div class="mt-3 text-secondary fw-semibold fs-5">Filtrando información...</div>
                  </div>
                </td>
              </tr>
              <tr v-else v-for="(items, index) in datosPaginados" :key="index.id"  class="text-center align-middle text-nowrap reducirTamaño">


                <td class="tabla-estiloCompreso">
                  <div class="mx-2">
                    <i class="bi bi-hash text-primary me-1"></i>
                    {{ items.idPostulante }}
                  </div>
                </td>

                <!-- CV -->
                <td v-if="items.posAdjunto != 1" class="text-center py-1">
                  <a :href="url + items.posAdjunto.slice(45)" target="_blank" class="btn btn-light py-1">
                    <i class="bi bi-download fs-6"></i>
                  </a>
                </td>
                <td v-else class="text-center">-</td>

                  <td :class="{
                        'text-primary': items.estadoActivo.slice(0,10) == 'CONTRATADO', 'text-danger': items.estadoActivo.slice(0,10) != 'CONTRATADO', 'text-warning': items.estadoActivo == 'EN PROCESO'
                      }" class="fw-bold "> {{ items.estadoActivo }}</td>
                      
                       <td> <button @click="abrirSolicitud(items.requerimiento)" class="btn btn-link-estilo reducirTamaño">{{ items.requerimiento }}</button> </td>
                <td
                  :class="{
                    'text-danger': JSON.parse(items.recordTrabajador).diasAcumulados >= 1260
                  }"
                >
                  {{
                    JSON.parse(items.recordTrabajador).diasAcumulados == 0
                      ? '0 días'
                      : JSON.parse(items.recordTrabajador).diasAcumulados == 1
                        ? '1 día'
                        : `${JSON.parse(items.recordTrabajador).diasAcumulados} días`
                  }}
                </td>
                <!-- Perfil -->
                <td><i class="bi bi-person-badge-fill text-secondary me-1"></i>{{ items.posPerProfesional }}</td>

                <!-- Nro Doc -->
                <td><i class="bi bi-credit-card-2-front text-primary me-1"></i>{{ items.posNroDocumento }}</td>

                <!-- Tipo Doc -->
                <td><i class="bi bi-card-heading text-info me-1"></i>{{ items.desTipDocumento }}</td>

                <!-- Paterno -->
                <td><i class="bi bi-person-fill text-secondary me-1"></i>{{ items.posApePaterno }}</td>

                <!-- Materno -->
                <td><i class="bi bi-person-fill text-secondary me-1"></i>{{ items.posApeMaterno }}</td>

                <!-- Nombres -->
                <td><i class="bi bi-person-lines-fill text-success me-1"></i>{{ items.posNombre }}</td>

                <!-- Ubigeo -->
                <td>
                  <i class="bi bi-geo-alt-fill text-danger me-1"></i>
                  {{ items.desDepartamento }} - {{ items.desProvincia }} - {{ items.desDistrito }}
                </td>

                <!-- Nacionalidad -->
                <td>
                  <i class="bi bi-flag-fill text-warning me-1"></i>
                  {{ items.desNacionalidad }}
                </td>

                <!-- Acciones -->
                <td class="py-1 px-1 text-center">

                  <button class="btn btn-outline-info boton-estiloCuadrado me-1" @click="mandar(items.idPostulante)">
                    <i class="bi bi-eye"></i>
                  </button>

                  <button class="btn btn-outline-success boton-estiloCuadrado me-1"
                    @click="editar(items.idPostulante, items.posNroDocumento)">
                    <i class="bi bi-pencil-fill"></i>
                  </button>

                  <button class="btn btn-outline-danger boton-estiloCuadrado" @click="eliminar(items.idPostulante)">
                    <i class="bi bi-trash3"></i>
                  </button>

                </td>

                <!-- ESTADOS -->
                <td v-if="items.posEstado == '002' && items.posMotBloqueo != '000'" class="text-danger fw-bold">
                  <i class="bi bi-x-octagon-fill me-1"></i> BLACKLIST
                </td>

                <td v-if="items.posEstado == '004' && items.posMotBloqueo != '000'" class="text-danger fw-bold">
                  <i class="bi bi-ban-fill me-1"></i> LISTA DE RESTRICCIÓN
                </td>

                <td v-if="items.posEstado == '001' && items.posMotBloqueo == '000'" class="text-success fw-bold">
                  <i class="bi bi-bag-plus me-1"></i> ACTIVO
                </td>

                <td v-if="items.posEstado == '002' && items.posMotBloqueo == '000'" class="text-danger fw-bold">
                  <i class="bi bi-slash-circle-fill me-1"></i> INACTIVO
                </td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
        <!-- Ir a la primera página -->
        <button class="btn btn-outline-primary btn-sm" @click="pag = 1" :disabled="pag === 1">
          <i class="bi bi-chevron-double-left"></i>
        </button>

        <!-- Retroceder -->
        <button class="btn btn-outline-primary btn-sm" @click="pag--" :disabled="pag === 1">
          <i class="bi bi-chevron-left"></i>
        </button>

        <!-- Texto de info -->
        <span class="pagination-info small">
          Página {{ pag }} de {{ totalPages }}
        </span>

        <!-- Avanzar -->
        <button class="btn btn-outline-primary btn-sm" @click="pag++" :disabled="pag === totalPages">
          <i class="bi bi-chevron-right"></i>
        </button>

        <!-- Ir a la última página -->
        <button class="btn btn-outline-primary btn-sm" @click="pag = totalPages" :disabled="pag === totalPages">
          <i class="bi bi-chevron-double-right"></i>
        </button>
      </div>
    </div>

    <EditarPostulantes class="mx-auto" v-if="!postulanteCondic" :numeroDocument="numeroDocument" />
    <NuevoPostulante class="mx-auto" v-if="!nuevoPostulante" />

  </div>


</template>

<script>
import NuevoPostulante from "@/components/ModSeleccion/Postulante/RegistrarPostulante.vue";
import EditarPostulantes from "@/components/ModSeleccion/Postulante/EditarPostulante.vue";
import Swal from "sweetalert2";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SolimanologListado",
  components: {
    EditarPostulantes,
    NuevoPostulante,
  },

  data() {
    return {
      selectores: "",
      combito: [],
      Respuesta: [],
      tabla1: true,
      retrocedere: "<<",
      avanzare: ">>",
      numeroDocument: Number,
      BotonTabla: false,
      postulanteCondic: true,
      adams: false,
      mostrarInput: true,
      nuevoPostulante: true,
      postulanteCondicion: true,
      dni_busqueda: "",
      prender: true,
      alerta: false,
      cerrarTable1: true,
      cerrarTable2: false,
      alertita: false,
      retro: false,
      avanzar: true,
      loading: false,
      NUM_RESULTS: 16, // Numero de resultados por página
      perPage: 16, // Número de resultados por página
      pag: 1, // Página inicial
      // JSON a mostrar
      url: "https://apitopas.gruposolimano.com.pe/Documentos/CV/",
    };
  },
  computed: {
    ...mapGetters("listadoPostulante", ["Info", "Loader", "Tabla1"]),

    informacion() {
      return this.tabla1 ? this.Info : this.Respuesta;
    },

    totalPages() {
      return Math.ceil(this.informacion.length / this.NUM_RESULTS) || 1;
      // return Math.max(1, Math.ceil(this.informacion.length / this.perPage));
    },

    datosPaginados() {
      // const start = (this.pag - 1) * this.NUM_RESULTS;
      // return this.informacion.slice(start, start + this.NUM_RESULTS);
      const start = (this.pag - 1) * this.perPage;
      return this.informacion.slice(start, start + this.perPage);
    },
  },

  methods: {
    ...mapActions("listadoPostulante", [
      "getAttributesPostulanteUsers",
      "getAttributesPostulante",
    ]),

    async Filtros() {
      if (this.dni_busqueda.length > 0) {
        this.tabla1 = false;
        this.Respuesta = [];

        const currentDni = this.dni_busqueda; // Captura el valor actual de dni_busqueda

        const isNumeric = !isNaN(parseFloat(currentDni)) && isFinite(currentDni);

        let apiUrl;
        if (isNumeric) {
          apiUrl = `Postulante/BusquedaxDniPos?dni=${currentDni}`;
        } else {
          apiUrl = `Postulante/BusquedaxDniPos?apellido=${currentDni}`;
        }

        this.axios.get(apiUrl)
          .then(response => {
            // Verifica que el valor actual de dni_busqueda sea igual al valor al que correspondía la respuesta
            if (currentDni === this.dni_busqueda) {
              this.Respuesta = response.data;
              console.log(response.data);
              this.pag = 1;
              this.loading = true;
              setTimeout(() => {
                this.loading = false;
              }, 900);

            }
          })
          .catch(error => {
            // Manejo de errores si es necesario
            console.log(error);
          });
        this.pag = 1; // Reiniciar a la primera página después de filtrar
      } else {
        this.tabla1 = true;
        this.pag = 1;
        

      }
    },


    realizarAccionAlAceptar() {
      const from = {
        idUsuario: this.selectores,
      };
      this.axios.put(`Usuario/ModificarUsuario`, from).then((r) => {
        console.log(r.data);
      });
    },

    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },

    listado() {
      this.tabla2 = false;
      this.BotonTabla = !this.BotonTabla;
      this.postulanteCondicion = true;
      this.postulanteCondic = true;
      this.nuevoPostulante = true;
      this.mostrarInput = true;
    },

    postulante() {
      this.BotonTabla = true;
      this.nuevoPostulante = false;
      this.postulanteCondicion = false;
      this.postulanteCondic = true;
      this.mostrarInput = false;
    },
    editar(nroDoc, documento) {
      this.getAttributesPostulanteUsers(nroDoc);
      this.BotonTabla = true;

      // console.log(nroDoc);
      this.numeroDocument = nroDoc;
      this.postulanteCondic = false;
      this.postulanteCondicion = false;
      this.mostrarInput = false;
      // this.$router.push("/EditarListado/" + nroDoc);
      console.log(this.numeroDocument);

      this.axios
        .get(`Usuario/ListarUsuarioxdni?nroDocumento=${documento}`)
        .then((r) => {
          this.combito = r.data;
          console.log(r.data);
        });
    },

    buscador() {
      this.adams = true;
    },

    eliminar(muere) {
      Swal.fire({
        title: "Deseas Eliminar",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire("¡Eliminado!", "El registro ha sido eliminado con éxito.", "success");
          this.axios.delete("Postulante/Eliminar/" + muere).then((datos) => {
            console.log(datos);
            this.dni_busqueda = "";
            this.getAttributesPostulante();
          });
        }
      });
    },

    // retroceder() {
    //   this.$router.push("/Dashboard");
    // },

    retroceso() {
      if (this.NUM_RESULTS === 16) {
        this.retro = false;
      } else {
        this.retro == true;
        this.NUM_RESULTS -= 16;
        this.pag -= 1;
      if (this.pag > 1) {
        this.pag--;
      }
    }
    },
    aumentar() {
      this.NUM_RESULTS += 16;
      this.pag += 1;
      if (this.NUM_RESULTS >= 16) {
        this.retro = true;
      } else {
        this.retro = false;
      if (this.pag < this.totalPages) {
        this.pag++;
      }
      if (this.NUM_RESULTS > this.Info.length) {
        this.avanzar = false;
      }
      // console.log(this.NUM_RESULTS);
    }
    },

    mandar(id) {
      this.$router.push("/usuarioinfo/" + id);
    },
    irInicio() {
      this.pag = 1;
    },
    irFinal() {
      this.pag = this.totalPages;
    },

    abrirSolicitud(id) {
      const routeData = this.$router.resolve({
        name: 'gestionSolicitud',
        params: { ide: id }
      });
      window.open(routeData.href, '_blank');
    },
  },
};
</script>

<style scoped>
.reducirTamaño {
  font-size: 0.65rem;
}

.bg-solimano {
  background: #1565C0;
}

.tituloResaltado {
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}

.boton-estiloPag {
  border: 1px solid rgb(199, 199, 199);
  background-color: white;
  color: rgb(32, 32, 32);
  padding: 0.6rem 1rem;
  border-radius: 0;
}

.boton-estiloCuadrado {
  padding: 0.20rem 0.55rem;
  cursor: pointer;
  /* Cambia el cursor a una mano */
}

.buscar-estiloCuadrado {
  border-radius: 0;
  font-size: 0.65rem;
  background-color: transparent;
  /* Fondo transparente */
}

.tabla-estiloCompreso {
  padding: 0.30rem 0.55rem;

}
</style>
